import { commonConstants } from '../constants';

export function common(state , action) {
  switch (action.type) {
    default:
        return {...state}
    }
}